import { useState } from "react";
import { getEvalRun } from "./service";

export default useEvalRun;

function useEvalRun(workspaceId, evalRunId) {
  const [evalRun, setEvalRun] = useState(undefined);
  const [isEvalRunLoading, setIsEvalRunLoading] = useState<boolean>(true);

  const fetchEvalRun = async () => {
    function init() {
      setIsEvalRunLoading(true);
    }

    function success(data) {
      setIsEvalRunLoading(false);
      setEvalRun(data);
    }

    function error(e) {
      setIsEvalRunLoading(false);
    }

    const request = { params: { workspaceId, evalRunId } };

    init();
    try {
      const response = await getEvalRun(request);
      success(response.data);
    } catch (e) {
      error(e);
    }
  };

  return {
    evalRun,
    fetchEvalRun,
    isEvalRunLoading,
  };
}
